export default fnToRunOnReady => {
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        fnToRunOnReady();
    } else {
        document.addEventListener('DOMContentLoaded', fnToRunOnReady);
    }
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/on-ready.js